import type {FunctionComponent} from 'react';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {Image} from '@app/components/Image';
import {useTranslation} from '@app/hooks/use-translation';
import type {LocalImageConfig} from '@app/hooks/use-local-image';
import {useLocalImage} from '@app/hooks/use-local-image';
import {LandingButtonLink} from '@app/components/landing-btn-link';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';

const IMAGE_CONFIG: LocalImageConfig = {
	default: '00214ca8f8037154c9cec7e80a838471.png',
	fr: 'a3fdffc22b63d1dc17bc94ff84e827a8.png',
};

export const LyricsSection: FunctionComponent = () => {
	const {t} = useTranslation();
	const src = useLocalImage(IMAGE_CONFIG);

	return (
		<LandingIllustrationSection
			imagePosition="left"
			description={
				<>
					<LandingHeading as="h2">
						{t('featureslandingpage_title_singalongwithlyrics_standalone-web', {
							ns: 'features',
						})}
					</LandingHeading>
					<LandingParagraph>
						{t('offlinelandingpage_text_takeyourlyricsoffline_standalone-web', {
							ns: 'offline',
						})}
					</LandingParagraph>
				</>
			}
			image={
				<Image
					aspectRatio="1440/840"
					sizes={{base: '100vw', md: '50vw'}}
					h={{base: '310px', md: '100%'}}
					src={src}
					alt={t('metatag_text_songlyrics_standalone-web', {ns: 'common'})}
				/>
			}
			cta={
				<LandingButtonLink
					tracking={{eventaction: 'discover', eventlabel: 'lyrics'}}
					href="/features/lyrics"
				>
					{t('offlinelandingpage_action_discoverlyrics_standalone-web', {
						ns: 'common',
					})}
				</LandingButtonLink>
			}
		/>
	);
};
